import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import persistState from 'redux-localstorage';
import { routerMiddleware } from 'connected-react-router';
import createMiddleware from './redux/middleware/clientMiddleware';
import rootReducer from './redux/rootReducer';

export default function configureStore(history, client) {
  const reduxRouterMiddleware = routerMiddleware(history);
  
  const middleware = [createMiddleware(client), reduxRouterMiddleware, thunk];

  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  const enhancer = composeEnhancers(
    applyMiddleware(...middleware),
    persistState()
  );

 return createStore(
    rootReducer(history),
    enhancer
 );
}